import React, { FC } from 'react';
import styled from 'styled-components';

export const ImageWrapper = styled.div<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 100%;
  width: 100%;
`;

export const ImageTile: FC<{
  src: string;
}> = ({ src }) => {
  return (
    <ImageWrapper>
      <img src={src} alt="tile" width="100%" loading="lazy" />
    </ImageWrapper>
  );
};
